import React from "react";

// Shared page/section title block (Phase 2). Gives every in-scope surface the
// same eyebrow → title → subtitle rhythm and a right-aligned actions slot.
// Pure layout — no API/behaviour. Use `eyebrow`, `title`, `subtitle`, inline
// `chips` (rendered next to the title) and an `actions` node on the right.
export const TitleBlock = React.forwardRef(function TitleBlock(
  { eyebrow, title, subtitle, chips, actions, className = "", testid, ...rest },
  ref
) {
  return (
    <div ref={ref} className={`title-block ${className}`} data-testid={testid} {...rest}>
      <div className="tb-main">
        {eyebrow ? <div className="u-label tb-eyebrow" data-testid={testid ? `${testid}-eyebrow` : undefined}>{eyebrow}</div> : null}
        <div className="flex items-center gap-2 flex-wrap">
          <h1 className="u-page" data-testid={testid ? `${testid}-title` : undefined}>{title}</h1>
          {chips}
        </div>
        {subtitle ? <p className="u-small tb-sub">{subtitle}</p> : null}
      </div>
      {actions ? <div className="tb-actions">{actions}</div> : null}
    </div>
  );
});

export default TitleBlock;
